import React from 'react'

export default ({ children }) => (
  <div className="body-wrap">{children}</div>
)
